module.exports = __webpack_public_path__ + "img/ranking_top2_big.8b748d06.webp";